<capra-toast class="error-toast" type="error">
  <h4 class="toast-header">Dataset creation failed</h4>
  <p class="toast-text">
    This can happen when the output data is incompatible.<br />
    Make sure the cell produces valid tabular results and try again
  </p>
</capra-toast>
